import React from 'react';

import './css/Footer.css';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>Copyright ©2024-2025 Rabbit Case Ltd | Last Updated | Concept by <a href='https://princeportfolio-6yav7ijxn-priyanshupatel1253-gmailcoms-projects.vercel.app/'>Priyanshu Patel</a> & <a href='https://sagarp2.github.io/SagarPanchal/'>Sagar Panchal</a></p>
        
          
        
        
       
      </div>
    </footer>
  );
};

export default Footer;
